export type TripItineraryCategory =
  | "car"
  | "flight"
  | "hotel"
  | "home"
  | "package"
  | "activity";

const ITINERARY_TYPE_TO_CATEGORY: Record<string, TripItineraryCategory> = {
  car: "car",
  flight: "flight",
  hotel: "hotel",
  home: "home",
  package: "package",
  "package-hotel": "package",
  "package-flight": "package",
  activity: "activity",
};

const TRAVEL_APP_MODAL_ACTIONS_BY_ITINERARY_TYPE: Record<
  string,
  string[]
> = {
  flight: ["cancel", "change", "cfar"],
  hotel: ["cancel", "change", "cfar"],
  car: ["cancel", "change"],
  home: ["cancel"],
  "package-hotel": ["cancel", "change"],
  "package-flight": ["cancel", "change"],
  activity: ["cancel"],
};

// Only itineraryType/action combos with a dedicated modal in TravelAppPage
// should route there; everything else (including unsupported combos like
// itineraryType=home&action=change) falls through to the normal view+modal
// flow in TripsList, which already knows how to render every trip.
export const getIsTravelAppModalAction = (
  itineraryType: string | string[] | null | undefined,
  action: string | string[] | null | undefined
) => {
  if (typeof itineraryType !== "string") return false;
  return (
    TRAVEL_APP_MODAL_ACTIONS_BY_ITINERARY_TYPE[itineraryType]?.includes(
      action as string
    ) ?? false
  );
};

// In the travel app, a trip-details deep link only cares about one itinerary
// type (e.g. `itineraryType=hotel`), so we skip fetching the other categories.
// Exception: a schedulechange deep link for `itineraryType=flight` doesn't
// tell us if the flight is standalone or part of a package, so packages must
// be fetched too.
export const shouldFetchItineraryCategory = (
  category: TripItineraryCategory,
  isTravelApp: boolean,
  itineraryType: string | string[] | null | undefined,
  action?: string | string[] | null
) => {
  if (!isTravelApp || typeof itineraryType !== "string") return true;
  if (
    itineraryType === "flight" &&
    action === "schedulechange" &&
    category === "package"
  ) {
    return true;
  }
  return ITINERARY_TYPE_TO_CATEGORY[itineraryType] === category;
};
